const MixinForm = {
  methods: {
    changeColumns() {
      this.internal_config.columns++;

      if (this.internal_config.columns === 5) {
        this.internal_config.columns = 1;
      }

      this.setColumns();
    },

    horizontalColumns() {

      if (this.internal_config.horizontal && this.internal_config.columns !== 1) {
        this.internal_config.columns = 1;
        this.setColumns();
      }
      let previousConfig = {};


      if (typeof this.internal_config.horizontal_config !== 'undefined')
        previousConfig = this.internal_config.horizontal_config

      previousConfig = {...previousConfig, mobile: this.internal_config.mobile};

      this.$root.$emit('configFields', JSON.parse(JSON.stringify(this.internal_config.fields || this.internal_config.dataList)),
        JSON.parse(JSON.stringify(previousConfig)), this.testAlan, JSON.parse(JSON.stringify(this.internal_config.horizontal_config_mobile)))

    },

    setColumns() {

      let container = this.$el.querySelector('.inputs-area');

      if (this.internal_config.columns <= 1) {
        container.classList.remove("form-row");

        container.querySelectorAll('.form-group').forEach(input => {
          for (let i = 1; i <= 12; i++) {
            input.parentElement.classList.remove("col-" + i);
          }
        })

      } else {

        container.classList.add("form-row");

        container.querySelectorAll('.form-group').forEach(input => {
          for (let i = 1; i <= 12; i++) {
            input.parentElement.classList.remove("col-" + i);
          }
          input.parentElement.classList.add(`col-${12 / this.internal_config.columns}`);
        })

      }
    },

    testAlan(data, dataMobile = false) {

      if (!this.internal_config.horizontal)
        return;


      this.internal_config.horizontal_config = data;
      if (dataMobile) {
        this.internal_config.horizontal_config_mobile = dataMobile;
      }

      let containerFields = this.$el.querySelector('.inputs-area');
      let placeBtn = this.$el.querySelector('.place-btn');
      let btn = this.$el.querySelector('.bt-sb');
      let container = this.$el.querySelector('.inputs-area');
      let dataValues = (this.device === 'mobile' && dataMobile) ? dataMobile : data;

      if (!dataValues.custom) {
        let fields = this.$el.querySelectorAll('.inputs-area [data-field-group-name]')
        fields.forEach((field) => {
          field.className = '';
        })

        containerFields.style.width = '100%';
        placeBtn.style.width = '100%';
        btn.style.bottom = '15px';
        container.classList.remove("form-row");

        return
      }

      containerFields.style.width = dataValues.container.width + '%';
      placeBtn.style.width = dataValues.btnPlace.width + '%';
      btn.style.bottom = dataValues.btnPlace.padding + 'px';
      container.classList.add("form-row");

      dataValues.fields.forEach((field) => {
        let fieldCurrent = this.$el.querySelector('.inputs-area [data-field-group-name="' + field.name + '"]');
        if (fieldCurrent) {
          fieldCurrent.className = '';
          fieldCurrent.classList.add(field.size);
        }
      });
    },
  }
}

export default MixinForm;



// WEBPACK FOOTER //
// ./src/components/editor/apps/Forms/MixinForm.js